import React from 'react';
import { connect } from 'react-redux';
import { resetCredentials as resetCredentialsConnect } from '../../../../stores/credentials-store';
import { AppState, ConnectedPropsWithoutDispatch } from '../../../../stores/redux-store';
import { applicationParameters } from '../../../../utilities/application-parameters';
import {
  AccountCheckMachineView as AccountCheckMachineViewImport,
  AccountCheckMachineViewProps,
} from '../../AccountCheckMachineView';

export type AccountCheckDirectorProps = PropsFromRedux & {
  AccountCheckMachineView?: React.ComponentType<AccountCheckMachineViewProps>;
};

export const AccountCheckDirectorPresenter: React.FC<AccountCheckDirectorProps> = ({
  resetCredentials,
  AccountCheckMachineView = AccountCheckMachineViewImport,
  session,
}) => {
  const externalReference =
    session?.externalReference || applicationParameters.get('externalReference');

  return (
    <AccountCheckMachineView onCancel={resetCredentials} externalReference={externalReference} />
  );
};

const mapStateToProps = (state: AppState) => {
  return {
    session: state.session.data,
  };
};

const mapDispatchToProps = {
  resetCredentials: resetCredentialsConnect,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedPropsWithoutDispatch<typeof connector>;

export const AccountCheckDirector = connector(AccountCheckDirectorPresenter);
